import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Name.scss";
import arrow from "../../../assets/arrow.png";
import { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";



export const destinyProfiles = {
  1: {
    title: "Name Number 1 – The Confident Personality",
    keywords: "Leadership · Independence · Authority",
    overview:
      "Name Number 1 reflects a bold, confident and authoritative outer personality. You appear strong, self-reliant and commanding to others.",
    strengths: [
      "Strong leadership presence",
      "Confident communication style",
      "Independent and decisive",
      "Projects authority"
    ],
    challenges: [
      "Appearing dominating",
      "Impatience with others",
      "Difficulty taking feedback",
      "Strong ego projection"
    ],
    guidance:
      "Balance confidence with humility to build stronger relationships."
  },

  2: {
    title: "Name Number 2 – The Gentle Personality",
    keywords: "Diplomacy · Cooperation · Calmness",
    overview:
      "Name Number 2 gives a calm, polite and cooperative outer personality. Others see you as gentle, trustworthy and emotionally aware.",
    strengths: [
      "Diplomatic communication",
      "Supportive and cooperative nature",
      "Good listener",
      "Pleasant public image"
    ],
    challenges: [
      "Appearing indecisive",
      "Over-adjusting to others",
      "Avoiding confrontation"
    ],
    guidance:
      "Stand your ground when needed. Confidence strengthens diplomacy."
  },

  3: {
    title: "Name Number 3 – The Expressive Personality",
    keywords: "Creativity · Communication · Charm",
    overview:
      "Name Number 3 reflects a cheerful, expressive and charismatic personality. People see you as lively, creative and communicative.",
    strengths: [
      "Excellent communication skills",
      "Creative self-expression",
      "Charming public presence",
      "Positive energy"
    ],
    challenges: [
      "Appearing inconsistent",
      "Lack of seriousness",
      "Scattered focus"
    ],
    guidance:
      "Structure your expression. Consistency builds credibility."
  },

  4: {
    title: "Name Number 4 – The Reliable Personality",
    keywords: "Discipline · Stability · Trust",
    overview:
      "Name Number 4 gives a practical, disciplined and dependable outer personality. People see you as reliable and hardworking.",
    strengths: [
      "Strong work ethic",
      "Dependable and organised",
      "Trustworthy image",
      "Systematic approach"
    ],
    challenges: [
      "Appearing rigid",
      "Resistance to change",
      "Over-serious attitude"
    ],
    guidance:
      "Flexibility enhances your reliability and approachability."
  },

  5: {
    title: "Name Number 5 – The Dynamic Personality",
    keywords: "Freedom · Versatility · Energy",
    overview:
      "Name Number 5 reflects an energetic, adaptable and adventurous personality. You appear lively, curious and flexible to others.",
    strengths: [
      "Adaptable communication style",
      "Quick thinking",
      "Social versatility",
      "Attractive personality"
    ],
    challenges: [
      "Appearing restless",
      "Inconsistency",
      "Difficulty committing"
    ],
    guidance:
      "Channel your energy with discipline for lasting impact."
  },

  6: {
    title: "Name Number 6 – The Caring Personality",
    keywords: "Responsibility · Warmth · Harmony",
    overview:
      "Name Number 6 gives a warm, caring and responsible public personality. Others see you as supportive, loving and dependable.",
    strengths: [
      "Caring and nurturing image",
      "Responsible behaviour",
      "Harmonious communication",
      "Family-oriented presence"
    ],
    challenges: [
      "Over-responsibility",
      "Interfering tendencies",
      "Expecting appreciation"
    ],
    guidance:
      "Care without controlling. Balance service with self-respect."
  },

  7: {
    title: "Name Number 7 – The Reserved Personality",
    keywords: "Wisdom · Depth · Mystery",
    overview:
      "Name Number 7 reflects a thoughtful, reserved and intelligent personality. People perceive you as deep, analytical and mysterious.",
    strengths: [
      "Intellectual presence",
      "Analytical communication",
      "Calm and composed image"
    ],
    challenges: [
      "Appearing distant",
      "Limited emotional expression",
      "Social withdrawal"
    ],
    guidance:
      "Share more openly. Connection strengthens your wisdom."
  },

  8: {
    title: "Name Number 8 – The Powerful Personality",
    keywords: "Authority · Ambition · Control",
    overview:
      "Name Number 8 gives a powerful, ambitious and authoritative public image. Others see you as confident, determined and commanding.",
    strengths: [
      "Strong leadership presence",
      "Professional image",
      "Goal-oriented mindset",
      "Commanding communication"
    ],
    challenges: [
      "Appearing controlling",
      "Work-centric behaviour",
      "Stress projection"
    ],
    guidance:
      "Balance power with empathy to gain lasting respect."
  },

  9: {
    title: "Name Number 9 – The Compassionate Personality",
    keywords: "Humanity · Emotion · Creativity",
    overview:
      "Name Number 9 reflects a compassionate, emotional and artistic personality. People see you as kind-hearted and understanding.",
    strengths: [
      "Empathetic public image",
      "Creative expression",
      "Broad-minded outlook"
    ],
    challenges: [
      "Emotional sensitivity",
      "Difficulty setting boundaries",
      "Over-giving"
    ],
    guidance:
      "Compassion is strongest when paired with self-respect."
  },

  11: {
    title: "Name Number 11 – The Inspirational Personality",
    keywords: "Intuition · Sensitivity · Vision",
    overview:
      "Name Number 11 gives an inspirational and intuitive public personality. Others sense depth, sensitivity and spiritual awareness in you.",
    strengths: [
      "Inspirational communication",
      "Heightened intuition",
      "Magnetic presence"
    ],
    challenges: [
      "Emotional overwhelm",
      "Anxiety",
      "Self-doubt"
    ],
    guidance:
      "Ground your energy. Calm expression strengthens inspiration."
  },

  22: {
    title: "Name Number 22 – The Masterful Personality",
    keywords: "Responsibility · Vision · Stability",
    overview:
      "Name Number 22 reflects a mature, responsible and powerful public image. People see you as capable of handling large responsibilities.",
    strengths: [
      "Strong sense of duty",
      "Practical leadership",
      "Vision combined with stability"
    ],
    challenges: [
      "Pressure of expectations",
      "Over-responsibility",
      "Fear of failure"
    ],
    guidance:
      "Lead step by step. Balance vision with emotional calm."
  },
};


const Name = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });


  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );


      setResultData(res.data);
      setShowReport(true);
    } catch (err) {
      setResultData({
        error: "Unable to generate your Destiny Number report. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  const destinyNum = resultData?.data?.numerology?.nameNumber;
  const profile = destinyNum ? destinyProfiles[destinyNum] : null;

  return (
    <div className="destiny-container">
      <InnerNav />

      <div className="destiny-content">
        <Zodiac />

        <div className="left-numerology">

          {/* FORM VIEW */}
          {!showReport && (
            <>
              <div className="header">
                <h1>Name Number Calculator</h1>
                <p>
                  Enter your name to discover your <strong>outer personality, public image, and how others perceive you</strong>.
                </p>
              </div>

              <div className="form-card">
                <form onSubmit={handleSubmit} className="form-grid">

                  <input
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <div className="dob-grid">
                    <select name="day" value={formData.day} onChange={handleChange}>
                      {[...Array(31)].map((_, i) => (
                        <option key={i + 1}>{i + 1}</option>
                      ))}
                    </select>

                    <select name="month" value={formData.month} onChange={handleChange}>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m) => (
                        <option key={m}>{m}</option>
                      ))}
                    </select>

                    <select name="year" value={formData.year} onChange={handleChange}>
                      {Array.from({ length: 110 }).map((_, i) => {
                        const y = 2025 - i;
                        return <option key={y}>{y}</option>;
                      })}
                    </select>
                  </div>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>


                  <button type="submit" className="primary-btn" disabled={loading}>
                    {loading ? "Generating..." : "Show My Destiny Number"}
                  </button>

                </form>
              </div>
            </>
          )}

          {/* REPORT VIEW */}
          {showReport && (
            <div className="report-card">

              <h1>Your Name Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  <div className="hero-number-box">
                    <div className="number-circle">{destinyNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Your Strengths</h3>
                    <ul>{profile?.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Your Challenges</h3>
                    <ul>{profile?.challenges.map((c, i) => <li key={i}>{c}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Related Links</h4>
          <div className="right-links">
            <Link to="/numerology/luckynum"><p><img src={arrow} /> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow} /> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow} /> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow} /> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow} /> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow} /> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow} /> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow} /> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow} /> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow} /> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow} /> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Name;